import { ApiBase } from '../ApiBase';
class DashboardV2ApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getDashboardStatistics = (params) => {
            return this.get('/v2/shops/current/dashboard/statistics', params);
        };
        this.countUnfulfilledOrders = () => {
            return this.get('/v2/shops/current/dashboard/statistics/unfulfilled-orders-count');
        };
    }
}
export const DashboardV2ApiClient = new DashboardV2ApiClientModel();
